<template>
  <div class="flex-col h-100"
    id="out">
    <!-- 滚动时显示 -->
    <div class="top-line"
      v-show="isFixed">
      <span class="iconfont iconarrowleft-outline back-info"
        @click="goBack"></span>
      <label class="news-title1">{{item.newsTitle | ellipsis(16)}}</label>
      <label>
        <i v-if="isMark"
          @click="markRel(false)"
           class="iconfont iconrating-fill"
          style="color:#d04a02;" />
        <i v-if="!isMark" @click="markRel(true)"
          class="iconfont iconrating-fill" />
      </label>
    </div>
    <div class="flex-col"
      v-show="!isFixed">
      <div class="flex-col">
        <div class="flex-row news-info"
          style="margin: 8px 1rem;">
          <span class="iconfont iconarrowleft-outline back-info"
            @click="goBack"></span>
          <label>
            <i v-if="isMark"
              @click="markRel(false)"
               class="iconfont iconrating-fill"
              style="color:#d04a02;" />
            <i v-if="!isMark" @click="markRel(true)"
              class="iconfont iconrating-fill" />
          </label>
        </div>
      </div>
      <div class="flex-col"
        style="margin: 5px 1rem 10px 1rem;">
        <label class="news-title">{{item.newsTitle}}</label>
        <div class="flex-row news-info">
          <label>{{item.newsFrom}}</label>
          <label>{{item.createTime}}</label>
        </div>
        <div class="flex-row news-info">
          <label style="margin-top: 0.5rem;">{{item.industry}}</label>
        </div>
      </div>
    </div>

    <div class="detail-info"
      id='detail-info'
      v-on:scroll.passive="handleScroll">
      <div class="market-content"
        v-html="item.newsContent">
      </div>
      <div class="flex-col news-tips">
        <span> {{ $t('newsTips') }}</span>
        <span>{{ $t('newsTips1') }}</span>
      </div>
      <div class="comment">
        <div class="comment-head">
          <div class="comment-title">评论</div>
          <div class="add-comment"
            @click="showComment">
            <span class="icon iconfont iconcomment-outline"> 我要评论 </span>
          </div>
        </div>
        <van-list :finished="finished"
          finished-text="没有更多了">
          <div v-for="comment in commentsList"
            :key="comment.id"
            class="comment-item">
            <div class="user-avatar">
              <van-image :src="comment.photoBase64" />
            </div>
            <div class="comment-cont">
              <div class="commnet-info">
                <span class="name">{{ comment.englishName }}</span>
                <span class="date">{{ comment.createTime }}</span>
              </div>
              <div class="cont">
                {{ comment.content }}
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <van-popup v-model="show"
      position="bottom"
      :style="{ height: '30%' }">
      <form action=""
        class="comment-info">
        <van-field v-model="message"
          style="background-color: #ebeaea;"
          rows="8"
          autosize
          type="textarea"
          placeholder="请输入评论" />
        <div class="send-button"
          @click="comment($event)">发送</div>
      </form>
    </van-popup>
  </div>
</template>

<script>
import common from "@common/common";
import webService from "../../network/webService";
import _ from "lodash";
import { Toast } from "vant";

export default {
  name: "NewsMarket",
  components: { Toast },
  data () {
    return {
      isFixed: false,
      isMark: false,
      item: {},
      show: false,
      message: "",
      commentsList: [],
      finished: false,
    };
  },
  filters: {
    ellipsis (_val, len) {
      if (!len) {
        len = 21;
      }
      if (!_val) return "";
      if (_val.length > len) {
        return _val.slice(0, len) + "...";
      }
      return _val;
    },
  },
  created () {
    var id = this.$route.query.id;
    var type = this.$route.query.type;
    if (id) {
      this.getMarketNewsById(id);
    }

    var FavoriteFilter = {
      FavoriteType: common.favoriteTypeEnum.NewsMarket,
      RelationShipId: id,
    }
    webService.GetUserFavoriteRelationshipsByRelId(FavoriteFilter).then((res) => {
      console.log(res.data)
      if (res.data) {
        this.isMark = true;
      }
      else {
        this.isMark = false;
      }
    });

    this.getComments();

    common.addViewHistory(
      this.$route.query.id,
      common.favoriteTypeEnum.NewsMarket
    );
  },
  methods: {
    handleScroll () {
      // let bodyinfo = document.getElementById("detail-info");
      // if (bodyinfo) {
      //   if (bodyinfo.scrollTop > 0) {
      //     this.isFixed = true;
      //   } else {
      //     this.isFixed = false;
      //   }
      // }
    },
    markRel (isboolmark) {
      this.isMark = isboolmark;
      let dto = {
        RelationshipId: this.item.id,
        FavoriteType: common.favoriteTypeEnum.NewsMarket,
        IsCancel: !isboolmark,
      };
      webService.addFavoriteRelationship(dto).then((res) => {
        console.log(res);
        if (res.data && res.data.success) {
          let msg = isboolmark ? "已收藏" : "取消收藏";
          this.$toast.success(msg);
        } else {
          Toast.fail(res.data.message);
        }
      });
    },
    changeNewsFrom (from) {
      let maps = [
        { origin: '交易线索', new: 'Mergemarket等' },
        { origin: '交易公告', new: 'Avcj,Mergemarket等' },
        { origin: '基金募资', new: 'Avcj' },
        { origin: '人员变动', new: 'Avcj' },
        { origin: '市场趋势', new: 'Avcj, 普华永道分析' },
      ]
      let res = _.find(maps, { origin: from });
      if (res) {
        return '主要来自：' + res.new;
      }
      return '来自：' + from;
    },
    processContent (data) {
      this.item = data;
      this.item.createTime = this.$moment(this.item.createTime).format(
        "DD/MM/YYYY"
      );
      this.item.newsFrom = this.changeNewsFrom(this.item.newsFrom);
    },
    getMarketNewsById (id) {
      webService.getMarketNewsById(id).then((res) => {
        this.processContent(res.data);
      });
    },
    goBack () {
      // this.$router.push({
      //     path: "/home/overview",
      // });
      this.$router.go(-1);
    },
    showComment () {
      this.message = "";
      this.show = true;
    },
    getComments () {
      let id = this.$route.query.id;
      webService.getComments(id).then((res) => {
        this.commentsList = res.data.data;
        this.commentsList.forEach((item) => {
          item.createTime = this.$moment(item.createTime).format(
            "yyyy-MM-DD HH:mm"
          );
        });
      });
    },
    comment () {
      //if (e.keyCode === 13) {
      //e.preventDefault();
      if (
        this.message == null ||
        this.message == undefined ||
        this.message.trim() == ""
      ) {
        this.$toast.fail(this.$t("notEmptyComment"));
        return;
      }
      let dto = {
        RelationID: this.$route.query.id,
        Content: this.message,
      };
      webService.addComment(dto).then((res) => {
        console.log(res);
        if (res.data.success) {
          this.getComments();
          this.$toast.success("评论成功");
          this.show = false;
        } else {
          this.$toast.fail("发生异常错误");
        }
      });
      //}
    },
  },
};
</script>

<style lang="scss" >
.top-line {
  margin: 1rem;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.news-title1 {
  color: #2d2d2d;
  font-size: 15px;
  font-weight: 600;
  flex: auto;
  padding-left: 5px;
}
.back-info {
  font-size: 25px;
  color: darkgray;
}
.news-title {
  color: #2d2d2d;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 1rem;
  max-height: 60px;
  overflow: hidden;
  min-height: 40px;
}
.news-info {
  justify-content: space-between;
  font-size: 12px;
  color: #7d7d7d;
  align-items: center;
}
.news-tips {
  border-top: 2px solid #f2f2f2;
  font-size: 12px;
  color: #bdbdbd;
  line-height: 24px;
  font-weight: 400;
  margin: 1rem;
}
.detail-info {
  border-top: 8px solid #f2f2f2;
  min-height: 50%;
  font-size: 14px;
  //padding: 1rem;
  color: #464646;
  overflow: auto;
  line-height: 1.4rem;
  .market-content {
    text-indent: 2em;
    padding: 1rem;
    img {
      width: 90%;
    }
  }
}
.split-info {
  height: 10px;
}

.comment {
  border-top: 8px solid #f2f2f2;
  padding: 1rem;
  //max-height: 300px;
  //overflow: auto;
  .comment-head {
    padding: 0.75rem 0rem;
    display: flex;
    .comment-title {
      font-size: 16px;
      font-weight: bold;
    }
    .add-comment {
      flex: 1;
      text-align: right;
      font-size: 16px;
      float: right;
      color: #d1590b;
      i {
        font-size: 12px;
      }
    }
  }
  .comment-item {
    display: flex;
    margin-bottom: 1rem;
    .user-avatar {
      width: 3.125rem;
      height: 3.125rem;
      text-align: center;
    }
    .comment-cont {
      padding-left: 0.6rem;
      flex: 1;
      .commnet-info {
        .date {
          float: right;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: 1px;
          color: #7d7d7d;
        }
      }
      .cont {
        padding-top: 0.375rem;
        font-size: 16px;
        line-height: 20px; // letter-spacing: 1px;
        color: #7d7d7d;
        word-break: break-all;
      }
    }
  }
}
.comment-info {
  padding: 20px 0 20px 20px;
  background-color: white;
  display: flex;
  flex-direction: row;
}
.send-button {
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e0301e;
}
</style>


// WEBPACK FOOTER //
// src/views/overview/NewsMarket.vue